import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps, useEffect, useState } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { DeviceType } from './types'
import {Button} from "@/components/ui/button.tsx";

interface CommunityOption {
  id: string
  name: string
}

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  device: DeviceType
  submitText: string
  communities?: CommunityOption[]
}

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
] as const

export default function Form({
  device,
  submitText,
  ...formProps
}: FormProps) {
  const initialStatus = device.status || 'active'
  const [status, setStatus] = useState(initialStatus)

  useEffect(() => {
    setStatus(initialStatus)
  }, [initialStatus])

  return (
    <InertiaForm
      transform={data => ({ device: data })}
      className="contents"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="gap-4 flex flex-col">
            <div className="">
              <Label htmlFor="name">Nom du terminal</Label>
              <Input
                  placeholder={"Nom du terminal"}
                  type="text"
                  name="name"
                  id="name"
                  defaultValue={device.name}
              />
              {errors.name && (
                  <div className="text-red-500 px-3 py-2 font-medium">
                    {errors.name.join(', ')}
                  </div>
              )}
            </div>

            <div className="">
              <Label htmlFor="code">Code d'identification du terminal (optionel)</Label>
              <Input
                  placeholder={"POS-XXXXXX"}
                  type="text"
                  name="code"
                  id="code"
                  defaultValue={device.code}
              />
              {errors.code && (
                  <div className="text-red-500 px-3 py-2 font-medium">
                    {errors.code.join(', ')}
                  </div>
              )}
            </div>

            <div className="">
              <Label htmlFor="status">Status</Label>
              <input type="hidden" name="status" value={status} />
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger id="status" className="w-full">
                  <SelectValue placeholder="Status" />
                </SelectTrigger>
                <SelectContent>
                  {statusOptions.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {errors.status && (
                  <div className="text-red-500 px-3 py-2 font-medium">
                    {errors.status.join(', ')}
                  </div>
              )}
            </div>

            <div className="inline">
              <Button
                  type="submit"
                  disabled={processing}
                  className="rounded-xs inline-block  cursor-pointer"
              >
                {submitText}
              </Button>
            </div>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
